export const topics = [
  {
    id: 't1',
    title: '把出租屋阳台改造成我的小花园，只花了 380 块',
    categoryId: 'life',
    authorId: 'u1',
    cover: 'https://readdy.ai/api/search-image?query=Small%20balcony%20garden%20full%20of%20green%20potted%20plants%20and%20hanging%20vines%2C%20warm%20morning%20sunlight%2C%20cozy%20urban%20apartment%2C%20honey%20orange%20toned%20editorial%20photography&width=1200&height=800&seq=hc-topic-t1&orientation=landscape',
    summary: '三平米的阳台，从堆杂物到绿意盎然。分享选品、布局和踩过的坑。',
    tags: ['阳台改造', '居家', '低成本'],
    replyCount: 128,
    viewCount: 8642,
    likeCount: 623,
    createdAt: '2026-10-12T09:20:00',
    isHot: true,
    content: '<p>搬进这个出租屋的时候，阳台堆满了房东留下的旧纸箱和一张坏掉的折叠桌。我花了一个周末清空它，然后开始了一场三平米的改造计划。</p><p>总预算控制在 380 元，其中花架 89 元、花盆和土 120 元、绿植 150 元、小工具 21 元。最大的心得是：<strong>不要一上来就买贵的植物</strong>，先从好养的绿萝、吊兰、虎皮兰开始。</p><p>布局上我用到了「高低错落」的原则，靠墙放三层木质花架，角落用一个旧椅子垫高，让视线不会一眼望到底。晚上加了一串暖光小灯，氛围感直接拉满。</p><p>如果你也想改造阳台，欢迎在评论区交流，我会尽量回复每一个问题。</p>',
  },
  {
    id: 't2',
    title: '极简生活一年后，我扔掉了 200 件东西',
    categoryId: 'life',
    authorId: 'u9',
    cover: 'https://readdy.ai/api/search-image?query=Minimal%20white%20shelf%20with%20a%20few%20carefully%20placed%20objects%20and%20a%20plant%2C%20warm%20soft%20natural%20light%2C%20calm%20clean%20aesthetic%20minimalist%20interior&width=1200&height=800&seq=hc-topic-t2&orientation=landscape',
    summary: '不是苦行，而是把注意力还给真正重要的东西。这是一份真实清单。',
    tags: ['极简', '整理', '生活方式'],
    replyCount: 86,
    viewCount: 5720,
    likeCount: 441,
    createdAt: '2026-10-11T15:40:00',
    isHot: false,
    content: '<p>一年前我做了一个决定：每周扔掉或送掉至少 4 件不再使用的东西。一年下来，数字停在了 200 出头。</p><p>最舍不得的是一些「以后可能用得上」的东西，但真正整理完才发现，所谓的以后从来没有来过。</p><p>极简不是让家变空，而是让每一件留下来的东西都有自己的位置和意义。现在我的桌面只剩下一盏灯、一台电脑和一杯水，反而更容易专注了。</p>',
  },
  {
    id: 't3',
    title: '在家复刻日式舒芙蕾松饼，第三次终于成功了',
    categoryId: 'food',
    authorId: 'u3',
    cover: 'https://readdy.ai/api/search-image?query=Tall%20fluffy%20Japanese%20souffle%20pancakes%20stacked%20on%20a%20plate%20with%20honey%20drizzle%2C%20warm%20soft%20light%2C%20clean%20food%20editorial%20photography%2C%20amber%20tones&width=1200&height=800&seq=hc-topic-t3&orientation=landscape',
    summary: '蛋白打发、火候、翻面时机，最关键的三步我都写在这里了。',
    tags: ['烘焙', '配方', '甜点'],
    replyCount: 214,
    viewCount: 12380,
    likeCount: 986,
    createdAt: '2026-10-10T11:05:00',
    isHot: true,
    content: '<p>舒芙蕾松饼看着简单，做起来是玄学。我失败了两次：第一次塌了，第二次糊了。</p><p>第三次总结出了三个关键点：<strong>一是蛋白打到湿性发泡即可</strong>，打太硬反而容易裂；<strong>二是全程最小火</strong>，盖上盖子焖；<strong>三是翻面要快</strong>，犹豫一秒就会塌。</p><p>配方：蛋 2 个、低筋面粉 30g、牛奶 25g、细砂糖 25g、香草精几滴。糖分三次加入蛋白，其他混匀后翻拌，不要画圈。</p><p>出锅后立刻撒糖粉、淋蜂蜜，趁热吃才对得起这份努力。评论区放了成品视频链接，欢迎来抄作业！</p>',
  },
  {
    id: 't4',
    title: '深夜食堂：一个人也要好好吃饭',
    categoryId: 'food',
    authorId: 'u9',
    cover: 'https://readdy.ai/api/search-image?query=Simple%20home%20cooked%20dinner%20for%20one%20with%20rice%20soup%20and%20greens%20on%20a%20wooden%20table%2C%20warm%20lamp%20light%2C%20cozy%20night%20mood%2C%20editorial%20food%20photography&width=1200&height=800&seq=hc-topic-t4&orientation=landscape',
    summary: '一人食不等于将就。分享我的一周晚餐清单和快手做法。',
    tags: ['一人食', '家常菜', '晚餐'],
    replyCount: 74,
    viewCount: 4310,
    likeCount: 356,
    createdAt: '2026-10-09T20:15:00',
    isHot: false,
    content: '<p>独居第三年，我慢慢把「随便吃点」换成了「认真做一顿」。</p><p>一周晚餐我通常这样安排：周一清冰箱、周二汤面、周三煎鸡胸配蔬菜、周四咖喱、周五奖励自己点一次外卖。</p><p>重点是备菜。周末花 40 分钟把蔬菜洗好分装，工作日回家 15 分钟就能上桌。仪式感不用很贵，一个好看的盘子就够了。</p>',
  },
  {
    id: 't5',
    title: '独自环岛骑行 30 天，我看到的不是风景',
    categoryId: 'travel',
    authorId: 'u2',
    cover: 'https://readdy.ai/api/search-image?query=Long%20coastal%20road%20with%20a%20lone%20cyclist%20at%20golden%20sunset%2C%20ocean%20on%20one%20side%2C%20warm%20orange%20sky%2C%20cinematic%20travel%20photography&width=1200&height=800&seq=hc-topic-t5&orientation=landscape',
    summary: '1200 公里、30 天、一个人。真正改变我的是路上遇到的那些人。',
    tags: ['骑行', '环岛', '独自旅行'],
    replyCount: 156,
    viewCount: 9870,
    likeCount: 812,
    createdAt: '2026-10-08T07:30:00',
    isHot: true,
    content: '<p>出发前很多人问我：一个人不无聊吗？真上路之后才发现，孤独反而是最好的礼物。</p><p>第 12 天我在一个渔村爆胎，一位大叔把我领回家，修好车、煮了一碗面。他说：年轻人，慢一点没关系，方向对就行。</p><p>30 天里我晒黑了三个度，也第一次真正学会了和自己相处。</p><p>装备清单我整理在评论区置顶，想去的朋友可以直接抄。</p>',
  },
  {
    id: 't6',
    title: '京都赏枫小众路线，帮你避开人潮',
    categoryId: 'travel',
    authorId: 'u2',
    cover: 'https://readdy.ai/api/search-image?query=Quiet%20Japanese%20temple%20garden%20with%20red%20maple%20leaves%20and%20stone%20path%2C%20soft%20autumn%20light%2C%20serene%20minimal%20travel%20photography%2C%20warm%20tones&width=1200&height=800&seq=hc-topic-t6&orientation=landscape',
    summary: '不去清水寺人挤人，这四条路线安静又出片。',
    tags: ['京都', '红叶', '攻略'],
    replyCount: 68,
    viewCount: 5240,
    likeCount: 402,
    createdAt: '2026-10-07T13:20:00',
    isHot: false,
    content: '<p>赏枫季的京都是人海，但只要早出发一小时、晚离开一小时，体验就完全不同。</p><p>我推荐的路线：大原三千院、真如堂、诗仙堂、清凉寺。前三个建议早上七点前到，光线柔和人也少。</p><p>交通上买一张巴士一日券，比每次单买划算。别贪多，一天两个点就够，慢慢逛才有味道。</p>',
  },
  {
    id: 't7',
    title: '读完《百年孤独》后我失眠了三天',
    categoryId: 'culture',
    authorId: 'u6',
    cover: 'https://readdy.ai/api/search-image?query=Open%20worn%20novel%20on%20a%20linen%20blanket%20with%20a%20cup%20of%20tea%20and%20dried%20flowers%2C%20soft%20afternoon%20light%2C%20quiet%20literary%20mood%2C%20warm%20beige%20editorial%20photography&width=1200&height=800&seq=hc-topic-t7&orientation=landscape',
    summary: '那场下了四年十一个月零两天的雨，淋湿的不只是马孔多。',
    tags: ['书评', '拉美文学', '马尔克斯'],
    replyCount: 92,
    viewCount: 6120,
    likeCount: 534,
    createdAt: '2026-10-06T22:10:00',
    isHot: false,
    content: '<p>合上书的那晚我很久没睡着。不是因为情节，而是因为那种挥之不去的宿命感。</p><p>布恩迪亚家族七代人的孤独，其实写的也是我们每个人。我们都在重复父辈的名字、性格和命运，却以为自己在开创什么新的东西。</p><p>马尔克斯最厉害的地方，是让魔幻变得理所当然——当雨水下了四年，你居然会觉得这就是生活本来的样子。</p>',
  },
  {
    id: 't8',
    title: '那些年被低估的国产老电影',
    categoryId: 'culture',
    authorId: 'u5',
    cover: 'https://readdy.ai/api/search-image?query=Vintage%20film%20projector%20with%20warm%20light%20beam%20and%20old%20film%20reels%2C%20retro%20cinema%20atmosphere%2C%20amber%20tones%2C%20editorial%20photography&width=1200&height=800&seq=hc-topic-t8&orientation=landscape',
    summary: '整理了一份片单，每一部都值得你现在就打开。',
    tags: ['电影', '片单', '国产'],
    replyCount: 110,
    viewCount: 7350,
    likeCount: 620,
    createdAt: '2026-10-05T16:00:00',
    isHot: false,
    content: '<p>很多人说国产片没有好电影，其实是被时间埋掉了。</p><p>我列的这份片单包括《小城之春》《马路天使》《乌鸦与麻雀》等，它们的美学放到今天看依然先锋。</p><p>尤其是《小城之春》，那种克制的情感和留白，是现在很少有电影敢做的。</p>',
  },
  {
    id: 't9',
    title: '今年最惊喜的国产剧，我连刷了三遍',
    categoryId: 'entertainment',
    authorId: 'u5',
    cover: 'https://readdy.ai/api/search-image?query=Cozy%20living%20room%20with%20tv%20glow%20and%20blanket%20on%20sofa%2C%20warm%20evening%20light%2C%20cinematic%20mood%2C%20editorial%20photography%2C%20amber%20tones&width=1200&height=800&seq=hc-topic-t9&orientation=landscape',
    summary: '不吹不黑，从剧本到表演都在线，聊聊它到底好在哪。',
    tags: ['国产剧', '推荐', '剧评'],
    replyCount: 246,
    viewCount: 15230,
    likeCount: 1120,
    createdAt: '2026-10-04T19:45:00',
    isHot: true,
    content: '<p>一开始我是冲着演员去的，结果被剧本圈粉。</p><p>它最难得的地方是「不把观众当傻子」：没有强行降智的反派，没有硬凑的感情线，每个人物的选择都有说服力。</p><p>节奏上前半段稍慢，但坚持到第八集之后就是一路高能。强烈建议不要倍速，很多细节藏在台词之外的沉默里。</p>',
  },
  {
    id: 't10',
    title: '演唱会现场到底值不值得抢票？',
    categoryId: 'entertainment',
    authorId: 'u8',
    cover: 'https://readdy.ai/api/search-image?query=Concert%20crowd%20silhouettes%20with%20warm%20stage%20lights%20and%20glow%20sticks%2C%20energetic%20live%20music%20atmosphere%2C%20honey%20orange%20tones%2C%20editorial%20photography&width=1200&height=800&seq=hc-topic-t10&orientation=landscape',
    summary: '从票价、位置到体验，一篇给纠结党的实用参考。',
    tags: ['演唱会', 'Live', '讨论'],
    replyCount: 178,
    viewCount: 8940,
    likeCount: 560,
    createdAt: '2026-10-03T21:00:00',
    isHot: false,
    content: '<p>我今年看了 6 场演唱会，说点掏心窝的话。</p><p>如果你只是喜欢那几首热歌，其实看录像就够；但如果你在某个深夜被某句歌词救过，那现场的情绪是几百块买得到、却一辈子忘不掉的东西。</p><p>位置方面，内场不一定最好，看台正对舞台反而视野更全。抢票前先想清楚你要的是「看清脸」还是「感受氛围」。</p>',
  },
  {
    id: 't11',
    title: '用一台旧笔记本搭建家庭服务器，全家人都受益',
    categoryId: 'tech',
    authorId: 'u4',
    cover: 'https://readdy.ai/api/search-image?query=Old%20laptop%20repurposed%20as%20home%20server%20on%20a%20shelf%20with%20small%20network%20devices%2C%20warm%20ambient%20light%2C%20clean%20tech%20editorial%20photography&width=1200&height=800&seq=hc-topic-t11&orientation=landscape',
    summary: '闲置笔记本别扔，一台就够跑相册、影音库和自动备份。',
    tags: ['服务器', '数码', '教程'],
    replyCount: 134,
    viewCount: 7650,
    likeCount: 588,
    createdAt: '2026-10-02T10:30:00',
    isHot: true,
    content: '<p>家里那台用了六年的笔记本一直吃灰，去年我把它装成了家庭服务器，到现在稳定运行 300 天。</p><p>它现在负责四件事：家庭相册自动备份、影音库、下载机和内网笔记。功耗只有 15W 左右，一个月电费不到 5 块。</p><p>软件我用的开源方案，具体步骤和踩坑记录都放在评论区，新手也能跟着做。</p>',
  },
  {
    id: 't12',
    title: '写给非程序员看的 AI 入门科普',
    categoryId: 'tech',
    authorId: 'u4',
    cover: 'https://readdy.ai/api/search-image?query=Abstract%20warm%20orange%20and%20cream%20gradient%20with%20connected%20nodes%20symbolizing%20neural%20network%2C%20minimal%20tech%20illustration%2C%20soft%20editorial%20style&width=1200&height=800&seq=hc-topic-t12&orientation=landscape',
    summary: '不用公式、不用代码，用生活化的比喻讲清 AI 是什么。',
    tags: ['AI', '科普', '入门'],
    replyCount: 98,
    viewCount: 10240,
    likeCount: 890,
    createdAt: '2026-10-01T14:00:00',
    isHot: false,
    content: '<p>很多人觉得 AI 很神秘，其实你可以先把它理解成一个「看过海量资料、特别会做阅读理解」的助手。</p><p>它不会真的「思考」，但能根据你的问题，预测出最合适的回答。就像你听一首歌的前奏，能猜出下一句旋律。</p><p>所以和 AI 相处的关键是：把要求说清楚，给它足够的背景。你越具体，它越靠谱。</p>',
  },
  {
    id: 't13',
    title: '早睡 30 天挑战，我的真实变化',
    categoryId: 'life',
    authorId: 'u1',
    cover: 'https://readdy.ai/api/search-image?query=Bedroom%20at%20night%20with%20a%20book%2C%20closed%20laptop%20and%20warm%20bedside%20lamp%2C%20calm%20cozy%20minimal%20interior%2C%20soft%20amber%20tones&width=1200&height=800&seq=hc-topic-t13&orientation=landscape',
    summary: '不吹效果，只说我身上真实发生的小改变。',
    tags: ['早睡', '自律', '习惯'],
    replyCount: 82,
    viewCount: 4980,
    likeCount: 420,
    createdAt: '2026-09-30T22:30:00',
    isHot: false,
    content: '<p>我给自己定的规则很简单：晚上 11 点放下手机，11 点半前关灯。</p><p>第 3 天最难，第 10 天开始适应，第 20 天之后身体会主动犯困。最大的变化不是变好看，而是早上醒来不再暴躁。</p><p>一个小技巧：把充电器放到客厅，手机就不会爬上床了。</p>',
  },
  {
    id: 't14',
    title: '一人食快手菜合集，15 分钟搞定',
    categoryId: 'food',
    authorId: 'u3',
    cover: 'https://readdy.ai/api/search-image?query=Quick%20weeknight%20meal%20bowl%20with%20eggs%20and%20vegetables%20on%20a%20simple%20plate%2C%20warm%20soft%20light%2C%20clean%20food%20editorial%20photography&width=1200&height=800&seq=hc-topic-t14&orientation=landscape',
    summary: '十道菜，零失败，专治下班不想做饭。',
    tags: ['快手菜', '食谱', '一人食'],
    replyCount: 96,
    viewCount: 6890,
    likeCount: 512,
    createdAt: '2026-09-29T18:20:00',
    isHot: false,
    content: '<p>下班回家最怕的就是「不知道吃什么」。我整理了十道 15 分钟内能上桌的菜。</p><p>核心思路是「一锅出」：番茄鸡蛋面、酱油炒饭、蒜香虾仁青菜、味增汤配饭团。</p><p>调料只用盐、生抽、蚝油、香油四样，厨房小白也不会翻车。</p>',
  },
  {
    id: 't15',
    title: '城市周边露营装备清单分享（附避坑）',
    categoryId: 'travel',
    authorId: 'u7',
    cover: 'https://readdy.ai/api/search-image?query=Cozy%20campsite%20at%20dusk%20with%20tent%20and%20warm%20lantern%20light%2C%20chairs%20around%20a%20small%20fire%2C%20golden%20hour%2C%20editorial%20outdoor%20photography&width=1200&height=800&seq=hc-topic-t15&orientation=landscape',
    summary: '第一次露营别乱买，这份清单帮你省一半钱。',
    tags: ['露营', '装备', '攻略'],
    replyCount: 64,
    viewCount: 4120,
    likeCount: 330,
    createdAt: '2026-09-28T09:00:00',
    isHot: false,
    content: '<p>周末露营火起来之后，很多人第一次就买了一堆用不上的装备。</p><p>我的建议是先租后买：帐篷、桌椅、天幕都可以租，确认自己真的喜欢再入手。</p><p>必备清单其实很短：帐篷、防潮垫、睡袋、照明、驱蚊、垃圾袋。其他的都是锦上添花。</p>',
  },
  {
    id: 't16',
    title: '博物馆奇妙日：我在故宫拍了 500 张照片',
    categoryId: 'culture',
    authorId: 'u10',
    cover: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20palace%20roof%20corner%20with%20red%20walls%20and%20golden%20tiles%20under%20warm%20sunlight%2C%20symmetrical%20architecture%20photography%2C%20amber%20tones&width=1200&height=800&seq=hc-topic-t16&orientation=landscape',
    summary: '关于构图、光线和那些藏在角落里的细节。',
    tags: ['故宫', '摄影', '人文'],
    replyCount: 58,
    viewCount: 3760,
    likeCount: 298,
    createdAt: '2026-09-27T11:40:00',
    isHot: false,
    content: '<p>故宫的每个角落都是构图练习场。我最喜欢拍的不是中轴线，而是偏殿的屋檐和光斑。</p><p>光线最好的是早上开馆后一小时和闭馆前两小时，斜光会让红墙的质感完全不一样。</p><p>技巧很简单：蹲下来拍、抬头拍、靠近拍。避开人群的秘诀是多等几分钟。</p>',
  },
  {
    id: 't17',
    title: '独立音乐现场，小众但很上头',
    categoryId: 'entertainment',
    authorId: 'u8',
    cover: 'https://readdy.ai/api/search-image?query=Intimate%20small%20live%20music%20venue%20with%20warm%20strings%20of%20lights%20and%20small%20stage%2C%20cozy%20indie%20atmosphere%2C%20amber%20tones%2C%20editorial%20photography&width=1200&height=800&seq=hc-topic-t17&orientation=landscape',
    summary: '票价几十块，却能听到最真诚的声音。',
    tags: ['独立音乐', 'Livehouse', '推荐'],
    replyCount: 71,
    viewCount: 3980,
    likeCount: 312,
    createdAt: '2026-09-26T20:50:00',
    isHot: false,
    content: '<p>比起体育馆的大舞台，我更喜欢几十人小场子的近距离。</p><p>演出前乐队会和观众聊天，演完还能在门口签名。那种「大家都在认真听」的氛围，是大场馆给不了的。</p><p>推荐先从城市的 Livehouse 周历开始，挑个周末去看看，票价通常不超过一杯咖啡的钱。</p>',
  },
  {
    id: 't18',
    title: '我的极简数字生活：手机 App 删到只剩 20 个',
    categoryId: 'tech',
    authorId: 'u9',
    cover: 'https://readdy.ai/api/search-image?query=Minimal%20phone%20home%20screen%20on%20a%20warm%20wooden%20desk%20with%20a%20plant%2C%20clean%20organized%20aesthetic%2C%20soft%20natural%20light%2C%20amber%20tones&width=1200&height=800&seq=hc-topic-t18&orientation=landscape',
    summary: '减少干扰之后，我每天多出了两个小时。',
    tags: ['数字极简', '效率', '自律'],
    replyCount: 88,
    viewCount: 5460,
    likeCount: 460,
    createdAt: '2026-09-25T08:10:00',
    isHot: false,
    content: '<p>我统计过，自己每天解锁手机 96 次，其中一半是下意识的滑动。</p><p>于是我把 App 删到只剩 20 个，关闭所有非必要通知，首页只留工具类应用。</p><p>结果是：刷手机的冲动少了，看书和发呆的时间多了。手机终于变回了工具，而不是主人。</p>',
  },
];